export default __webpack_public_path__ + "static/media/professorJournal.a6f8bb8c.pdf";